import permission from '@/configs/permission';
import userRole from '@/configs/role';
import store from '@/store';

const SCOPE_ROUTES = 'routes';
const SCOPE_FUNCTIONS = 'functions';

export default class AuthorizationService {
  permission;
  authUser = undefined;
  authRole = undefined;

  constructor () {
    this.permission = permission;
    if (store.state.userStore.user) {
      this.authUser = store.state.userStore.user;
    }
    this.setAuthRole();
  }

  setAuthRole () {
    if (store.state.userStore.role) {
      this.authRole = store.state.userStore.role;
    }
  }

  /**
   @var string: scope - routes or functions
   @var string: target - the route name or the function name
   @var string: routeGroup
   @return boolean
  */
  hasPermission (scope, target, routeGroup) {
    if (scope !== SCOPE_FUNCTIONS && scope !== SCOPE_ROUTES) return false;

    if (!this.validateAuthUser()) return false;
    if (!this.validateAuthRole()) return false;

    if (scope === SCOPE_ROUTES) {
      return this.validateScopeRoute(routeGroup, target);
    }

    return this.validateScopeFunction(routeGroup, target);
  }

  validateScopeRoute (routeGroup, routeName) {
    const permissionByUserType = permission[this.authRole];

    if (!permissionByUserType) return false;

    const permissionByRouteGroup = permissionByUserType[routeGroup];

    if (!permissionByRouteGroup) return false;

    if (!permissionByRouteGroup.routes || permissionByRouteGroup.routes.length <= 0) return false;

    return permissionByRouteGroup.routes.indexOf(routeName) !== -1;
  }

  validateScopeFunction (routeGroup, functionName) {
    const permissionByUserType = permission[this.authRole];

    if (!permissionByUserType) return false;

    const permissionByRouteGroup = permissionByUserType[routeGroup];

    if (!permissionByRouteGroup) return false;

    if (!permissionByRouteGroup.functions || permissionByRouteGroup.functions.length <= 0) return false;

    return permissionByRouteGroup.functions.indexOf(functionName) !== -1;
  }

  /**
   @return array
   */
  getAllAccessibleRoutesByUser (userType = undefined) {
    this.setAuthRole();
    if (!userType) {
      userType = this.authRole;
    }

    let result = [];
    const permissionByUserType = permission[userType] ?? [];
    Object.keys(permissionByUserType).forEach(item => {
      result = [...result, ...permissionByUserType[item].routes];
    });
    return result;
  }

  validateAuthRole () {
    const roles = [
      userRole.admin,
      userRole.vendor,
    ];
    return roles.indexOf(this.authRole) !== -1;
  }

  validateAuthUser () {
    return !!this.authUser;
  }
}
